import useApiClient from "../../useApiClient";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { withNetworkErrorHandling } from "../../helpers/withNetworkErrorHandling";

const useCompletedTasksAPIClient = () => {
  const { get } = useApiClient();
  const { activeUser } = useSelector((state) => state.user);

  const getCompletedTasks = useCallback(async () => {
    const response = await withNetworkErrorHandling(() =>
      get(`users/${activeUser.userId}/tasks?completed=true`),
    );
    return response?.message;
  }, [activeUser, get]);

  return { getCompletedTasks };
};

export default useCompletedTasksAPIClient;
